/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import BusinessIcon from "@mui/icons-material/Business";
import {
  getCompanyMoversForProjectOrSystem,
  MonitorCompanyMovers,
} from "../../api/cirrommonitor";
import {
  RecentMoversPanel,
  RecentMoversPanelConfig,
} from "./RecentMoversPanel";

const config: RecentMoversPanelConfig<MonitorCompanyMovers> = {
  title: "Recent Company Movers",
  subheader:
    "Contacts who recently changed companies - high-value opportunities",
  emptyMessage: "No recent company movers detected",
  icon: BusinessIcon,
  avatarColor: "success.main",
  trendingColor: "success",
  fetchFunction: getCompanyMoversForProjectOrSystem,
  getOldValue: (item) => item.old_company,
  getNewValue: (item) => item.new_company,
  seeMoreTab: "job_movers",
};

export const CompanyMoversPanel: React.FC<{
  isDataProject: boolean;
  dataProjectId: number;
  integratedSystemId: number;
}> = ({ isDataProject, dataProjectId, integratedSystemId }) => {
  return (
    <RecentMoversPanel
      isDataProject={isDataProject}
      dataProjectId={dataProjectId}
      integratedSystemId={integratedSystemId}
      config={config}
    />
  );
};
